import appConfig from '../appConfig';

// eslint-disable-next-line import/prefer-default-export
export const BASE_CARD_URL = `${appConfig.cardURL}/kauifunc`;
export const CARD_VIEW_URL = `${BASE_CARD_URL}/card-view`;
export const CARD_URL = `${BASE_CARD_URL}/card`;
export const CARD_ATTACHMENT_URL = `${BASE_CARD_URL}/card-attachment`;
export const CARD_COMMENT_URL = `${BASE_CARD_URL}/card-comment`;



// WEBPACK FOOTER //
// ./src/js/constants/workspaceCards.js